var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Components, PropertyConverters, Utils, P, PCSS, CustomElement, Watch, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemDataSourceElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
let PacemSelectElement = class PacemSelectElement extends PacemDataSourceElement {
    constructor() {
        super(...arguments);
        this.emptyOption = true;
    }
    toggleReadonlyView(readonly) {
        this._repeater.hidden = readonly;
        this._span.hidden = !readonly;
    }
    // no actual need to be idem-potent...
    // (take care in future)
    get inputFields() {
        return [this._select];
    }
    _manageDom(evt) {
        const args = evt.detail, item = args.item;
        let option = args.dom.find(o => o instanceof HTMLOptionElement);
        option.value = item.value;
        option.textContent = item.viewValue;
        option.disabled = item.disabled;
        option.selected = this.isDataSourceItemSelected(item);
        (Utils.isNullOrEmpty(option.value) ? Utils.addClass : Utils.removeClass).apply(this, [option, PCSS + '-watermark']);
    }
    onChange(evt) {
        let select = this._select, selectedIndex = select.selectedIndex, datasource = this.adaptedDatasource, item = selectedIndex >= 0 && datasource[selectedIndex], value;
        if (item != null) {
            value = item.value;
        }
        else
            value = undefined;
        return Utils.fromResult(this.value = value);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            // case 'required':
            case 'placeholder':
            case 'emptyOption':
                this.databind();
                break;
        }
    }
    buildAdaptedDatasource(ds = this.datasource) {
        let adapted = super.buildAdaptedDatasource(ds);
        if (adapted && this.emptyOption) {
            adapted.splice(0, 0, { viewValue: this.placeholder || '', value: undefined, data: undefined });
        }
        return adapted;
    }
    handleDatasourceMismatch(ds) {
        if (this.emptyOption) {
            super.handleDatasourceMismatch(ds);
        }
        else {
            // change value, since it does not exist in database and there's not null/empty fallback...
            if (Utils.isNullOrEmpty(ds)) {
                this.value = void 0;
            }
            else {
                this.value = ds[0].value;
                // ...you'll re-enter the acceptValue procedure with hopefully more luck.
            }
        }
    }
    ;
    acceptValue(val) {
        const ds = this.adaptedDatasource, item = ds && ds.filter(i => this.isDataSourceItemSelected(i, val));
        //let item = this.datasource && this.datasource.filter(i => this.isItemSelected(i));
        if (item && item.length == 1)
            this._select.selectedIndex = ds.indexOf(item[0]);
        else {
            this._select.value = undefined;
            let opts = this._select.options;
            if (opts.length > 0 && Utils.isNullOrEmpty(opts[0].value)) {
                this._select.selectedIndex = 0;
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        //select.addEventListener("change", this.changeHandler, false);
        var options = { capture: false, passive: false };
        this._select.addEventListener("wheel", this.emitHandler, options);
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._select)) {
            //select.removeEventListener("change", this.changeHandler, false);
            var options = { capture: false, passive: false };
            this._select.removeEventListener("wheel", this.emitHandler, options);
        }
        super.disconnectedCallback();
    }
};
__decorate([
    ViewChild('select')
], PacemSelectElement.prototype, "_select", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemSelectElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(`span.${PCSS}-readonly`)
], PacemSelectElement.prototype, "_span", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemSelectElement.prototype, "emptyOption", void 0);
PacemSelectElement = __decorate([
    CustomElement({
        tagName: P + '-select', template: `<${P}-repeater datasource="{{ :host.adaptedDatasource }}" on-${Components.RepeaterItemCreateEventName}=":host._manageDom($event)">
    <select class="${PCSS}-select ${PCSS}-viewfinder">
        <template>
            <option></option>
        </template>
    </select>
</${P}-repeater><span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span><${P}-content></${P}-content>`, shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemSelectElement);
export { PacemSelectElement };
